import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Card primitive. Emits `data-ui-card`, `data-variant`, `data-tone`. The
 * `flagged` tone applies the same left-border treatment used on flagged
 * response rows; `raised` adds a heavier shadow for modal-like surfaces.
 *
 * The host stylesheet maps the attributes to tokens — see
 * `apps/web/src/styles.css` and `docs/design-system.md`.
 */
export function Card(props) {
    const { variant = 'default', tone = 'neutral', heading, children, ...rest } = props;
    return (_jsxs("div", { "data-ui-card": "", "data-variant": variant, "data-tone": tone, ...rest, children: [heading !== undefined ? _jsx("div", { "data-ui-card-title": "", children: heading }) : null, children] }));
}
//# sourceMappingURL=Card.js.map